/*
Starting here and Continuing until Noted all code is provided with RESTRICTED RIGHTS:
Restricted Rights
Contract No.
BluePath Labs
2101 L St NW, Suite 800
Washington, DC 20037
The Government's rights to use, modify, reproduce, release, perform, display, or disclose this software are restricted by paragraph (b)(3) of the Rights in Noncommercial Computer Software and Noncommercial Computer Software Documentation clause contained in the above identified contract. Any reproduction of computer software or portions thereof marked with this legend must also reproduce the markings. Any person, other than the Government, who has been provided access to such software must promptly notify the above named Contractor.
*/

import axiosInstance from '../services/axiosInstance';
import { envUrls } from './env';

// Uncomment this to test localhost
// envUrls.bluelensService = 'http://localhost:2097';

export default new (class BlueLensService {
  // BlueLens API
  async fetchOrganizationData(payload) {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await axiosInstance.post(
      `${envUrls.bluelensService}/organizations`,
      payload,
      {
        headers: headers,
      }
    );
    return response.data;
  }

  async fetchEntityData(entityId) {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await axiosInstance.get(
      `${envUrls.bluelensService}/organizations/id/${entityId}`,
      {
        headers: headers,
      }
    );
    return response.data;
  }
})();

/*
Ending here, all code as  noted above is provided with RESTRICTED RIGHTS:
Restricted Rights
Contract No.
BluePath Labs
2101 L St NW, Suite 800
Washington, DC 20037
The Government's rights to use, modify, reproduce, release, perform, display, or disclose this software are restricted by paragraph (b)(3) of the Rights in Noncommercial Computer Software and Noncommercial Computer Software Documentation clause contained in the above identified contract. Any reproduction of computer software or portions thereof marked with this legend must also reproduce the markings. Any person, other than the Government, who has been provided access to such software must promptly notify the above named Contractor.
*/
